import { Box, Grid, Text } from "@chakra-ui/react";
import { formatMoneyWithSymbol } from "@verivest/shared-components";
import { InvestmentModel } from "@verivest/shared-components/src/api/models";
import { ManagerModel } from "@verivest/shared-components/src/api/models/Manager/Manager";
import { formatDateMMDDYYYY } from "@verivest/shared-components/src/utils/dates";
import React from "react";
import { InvestmentCardLabelValue } from "../../../horizontal-cards/InvestmentCardLabelValue";
import { PendingInvestmentCard } from "../../../horizontal-cards/PendingInvestmentCard";
import { getOpportunityFeaturedImage } from "@verivest/shared-components/src/utils/opportunities";

interface WLManagerPendingInvestmentsProps {
  manager?: ManagerModel;
  refresh: () => void;
  investments: InvestmentModel[];
}
export const WLManagerPendingInvestments = ({
  manager,
  refresh,
  investments: pendingInvestments,
}: WLManagerPendingInvestmentsProps) => {
  return (
    <Box w="100%" mb={16}>
      <Text textStyle="h2" mb={5}>
        Pending investments
      </Text>
      <Box w="100%">
        {pendingInvestments.map((investment) => (
          <PendingInvestmentCard
            key={`investment-card-${investment.id}`}
            imageUrl={
              investment.offering?.opportunity
                ? getOpportunityFeaturedImage(investment.offering.opportunity)
                : undefined
            }
            header={investment.offering?.name}
            manager={manager}
            investmentId={investment.id as string}
            actionIsRequired={true}
            isDeletable={!investment.dsEnvelopeId}
            refresh={refresh}
          >
            <Grid gridTemplateColumns={"1fr 3fr"} gap={2}>
              <InvestmentCardLabelValue
                label="Account"
                value={
                  investment.account?.name ||
                  investment.account?.nameOfRecord ||
                  ""
                }
              />
              <InvestmentCardLabelValue
                label="Amount"
                value={formatMoneyWithSymbol(investment.amount || 0)}
              />
              <InvestmentCardLabelValue
                label="Submitted"
                value={formatDateMMDDYYYY(investment.createdAt) || "-"}
              />
            </Grid>
          </PendingInvestmentCard>
        ))}
      </Box>
    </Box>
  );
};
